import { useAuthQuery } from 'app/api_v2/auth/queries';
import { isBackoffice, isGeneral } from 'app/helpers/userRoles';
import React from 'react';
import { Navigate } from 'react-router-dom';

interface HasToBeBackofficeGuardProps {
  children: React.ReactNode;
}

export const HasToBeBackofficeGuard = (props: HasToBeBackofficeGuardProps) => {
  const { children } = props;

  const { isSuccess, data } = useAuthQuery();

  if (isSuccess && !data) {
    return <Navigate to={'/auth/login'} />;
  }

  if (isSuccess && data && !isBackoffice(data) && !isGeneral(data)) {
    return <Navigate to={'/dashboard'} />;
  }

  if (isSuccess) {
    return <>{children}</>;
  }
  return null;
};

export default HasToBeBackofficeGuard;
